import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageMeta from '../../components/PageMeta';
import './ContentPage.css';

export default function ResourcePage({ resource }) {
  if (!resource) return null;

  return (
    <div className="content-page">
      <PageMeta title={resource.title} description={resource.description} path={resource.path} />
      <Header />
      <header className="content-hero">
        <div className="content-hero-inner">
          <h1 className="content-hero-title">{resource.title}</h1>
          <p className="content-hero-desc">{resource.description}</p>
        </div>
      </header>

      <main className="content-main">
        {resource.sections.map((block, index) => (
          <section key={block.h || index} className="content-block">
            <h2>{block.h}</h2>
            {block.p?.map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
            {block.list && (
              <ul>
                {block.list.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            )}
          </section>
        ))}

        <div className="content-related">
          <h2>Related resources</h2>
          <ul className="content-related-links">
            <li><Link to="/guides">Browse all guides</Link></li>
            <li><Link to="/seller-guide">Seller Guide</Link></li>
            <li><Link to="/farmer-verification">Farmer Verification</Link></li>
            <li><Link to="/farmer-support">Farmer Support</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/contact">Contact us</Link></li>
          </ul>
        </div>
      </main>

      <Footer />
    </div>
  );
}
